import Tool from '../../common/tool';
/** 底部 Tabbar、回到顶部（与 kingshiperMobile 导航行为一致） */
var MobileNavigationMain = /** @class */ (function () {
    function MobileNavigationMain(root) {
        this.root = root;
        this.userLogin = (root.getAttribute('data-user-login') || '0').toString();
        this.init();
    }
    MobileNavigationMain.prototype.init = function () {
        this.setActiveTab();
        this.bindUserTab();
        this.bindToTop();
        this.bindScrollService();
    };
    /** 根据当前 path 高亮对应 tab（data-url 多段用 & 分隔） */
    MobileNavigationMain.prototype.setActiveTab = function () {
        var path = window.location.pathname || '/';
        var items = Tool.$_selectAll(this.root, 'li');
        items.forEach(function (li) {
            var a = li.querySelector('a[data-url]');
            if (!a)
                return;
            var raw = a.getAttribute('data-url') || '';
            var segments = raw.split('&').map(function (s) { return s.trim(); }).filter(Boolean);
            var match = false;
            for (var i = 0; i < segments.length; i++) {
                var seg = segments[i];
                // 高亮规则 首页
                if (seg === '/home' || seg === '/') {
                    if (path === '/' || path === '/index.html' || path === '' || /\/help\.html$/i.test(path)) {
                        match = true;
                    }
                    // 高亮规则 我的
                }
                else if (seg === '/user') {
                    if (path === '/user' ||
                        path.indexOf('/user/') === 0 ||
                        path === '/exchange-center' ||
                        path === '/exchange-center.html' ||
                        path.indexOf('/exchange-center/') === 0) {
                        match = true;
                    }
                }
                else if (seg && path.indexOf(seg) === 0) {
                    match = true;
                }
            }
            if (match)
                li.classList.add('active');
            else
                li.classList.remove('active');
        });
        // 未匹配任何项时默认首页
        if (!Tool.$_select(this.root, 'li.active')) {
            var home = Tool.$_select(this.root, '.nav-homepage');
            if (home)
                home.classList.add('active');
        }
    };
    MobileNavigationMain.prototype.bindUserTab = function () {
        var _this = this;
        var userLi = Tool.$_select(this.root, '.nav-user');
        if (!userLi)
            return;
        var link = Tool.$_select(userLi, 'a');
        link.addEventListener('click', function (e) {
            e.preventDefault();
            if (_this.userLogin === '1') {
                window.location.href = '/user';
            }
            else {
                window.location.href = '/userlogin';
            }
        });
    };
    MobileNavigationMain.prototype.bindToTop = function () {
        var service = document.querySelector('.daetool-footer-service');
        var btn = document.querySelector('.daetool-footer-service .to-top-btn');
        if (!service || !btn)
            return;
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    };
    MobileNavigationMain.prototype.bindScrollService = function () {
        var service = document.querySelector('.daetool-footer-service');
        if (!service)
            return;
        var toggle = function () {
            if (window.scrollY > 280)
                service.classList.add('show');
            else
                service.classList.remove('show');
        };
        toggle();
        window.addEventListener('scroll', toggle, { passive: true });
    };
    return MobileNavigationMain;
}());
export default MobileNavigationMain;
/** 防 common.js 与 navigation 内 boot 重复初始化 */
var MOBILE_BOTTOM_NAV_BOUND = 'data-mobile-nav-bound';
/**
 * 初始化底部 Tabbar（高亮、我的 Tab 跳转、回顶等）。
 * 与 `mobileNavBoot.js`、commonMain 共用；已绑定则直接返回。
 */
export function tryInitMobileBottomNav() {
    var el = document.getElementById('bottom-nav');
    if (!el || el.getAttribute(MOBILE_BOTTOM_NAV_BOUND) === '1')
        return;
    el.setAttribute(MOBILE_BOTTOM_NAV_BOUND, '1');
    if (document.body)
        document.body.classList.add('has-mobile-bottom-nav');
    new MobileNavigationMain(el);
}
